import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft, Share2, ChevronDown } from 'lucide-react';
import { MetaTags } from '../../../../components/SEO/MetaTags';
import { RelatedBlogPosts } from '../../../../components/Blog/RelatedBlogPosts';
export function BlogPostCovertNarcissistJA() {
  const articleData = {
    title: 'あなたの元カレは隠れナルシシストですか？（テキストは嘘をつかない）',
    description: 'あなたの元カレが隠れナルシシストかどうか疑問に思っていますか？当社のAIがテキストメッセージで即座に検出する7つの微妙な操作的行動を発見してください。',
    slug: 'is-your-ex-a-covert-narcissist',
    publishDate: '2025-03-08',
    author: 'Toxic Detector 編集部'
  };
  const faqSchema = {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: [{
      '@type': 'Question',
      name: '隠れナルシシストとは何ですか？また、あからさまなナルシシストとどう違いますか？',
      acceptedAnswer: {
        '@type': 'Answer',
        text: '隠れナルシシストは、明白であからさまなナルシシストとは異なり、魅力、微妙な感情的戦術、受動的攻撃的なメッセージの背後に操作的な行動を隠します。'
      }
    }, {
      '@type': 'Question',
      name: 'AIはテキストメッセージで隠れナルシシズムを検出できますか？',
      acceptedAnswer: {
        '@type': 'Answer',
        text: 'はい。Toxic Detectorは、トーン、罪悪感の誘発、ラブボミングのサイクル、矛盾、感情操作のパターンを分析して、隠れナルシシストの行動にフラグを立てます。'
      }
    }, {
      '@type': 'Question',
      name: 'テキストでの隠れナルシシストの一般的な行動は何ですか？',
      acceptedAnswer: {
        '@type': 'Answer',
        text: '感情操作、ガスライティング、受動的攻撃的なコメント、被害者を演じること、ラブボミングとその後の撤回、微妙なコントロールなどです。'
      }
    }, {
      '@type': 'Question',
      name: '隠れナルシシストから身を守るにはどうすればよいですか？',
      acceptedAnswer: {
        '@type': 'Answer',
        text: 'メッセージを記録し、直感を信じ、境界線を維持し、Toxic Detectorのようなツールを使用して操作的なパターンを客観的に特定してください。'
      }
    }]
  };
  const articleSchema = {
    '@context': 'https://schema.org',
    '@type': 'Article',
    headline: articleData.title,
    description: articleData.description,
    image: 'https://toxicdetector.com/images/logo.png',
    author: {
      '@type': 'Person',
      name: articleData.author
    },
    datePublished: articleData.publishDate,
    publisher: {
      '@type': 'Organization',
      name: 'ToxicDetector',
      logo: {
        '@type': 'ImageObject',
        url: 'https://toxicdetector.com/images/logo.png'
      }
    }
  };
  const handleShare = async () => {
    try {
      await navigator.share({
        title: articleData.title,
        text: articleData.description,
        url: 'https://toxicdetector.com/'
      });
    } catch (err) {
      navigator.clipboard.writeText(window.location.href);
      alert('リンクがクリップボードにコピーされました！');
    }
  };
  return <>
      <MetaTags title="あなたの元カレは隠れナルシシストですか？AIが操作を検出する方法 | ToxicDetector" description="あなたの元カレが隠れナルシシストかどうか疑問に思っていますか？当社のAIが即座に検出する7つの微妙な操作的行動を発見してください。" keywords="隠れナルシシストの兆候, 隠されたナルシシストの行動, ナルシシストの操作テキスト, AIナルシシスト検出器" canonical={`https://toxicdetector.com/ja/blog/${articleData.slug}`} ogType="article" ogImage="https://cdn.magicpatterns.com/uploads/eYBGg4SniMpbkGoP3a2Uyt/file_00000000bb6072439a9d5e3820051ce3.png" schema={[faqSchema, articleSchema]} data-id="element-7374" />
      <div className="flex flex-col w-full min-h-screen bg-gradient-to-b from-stone-50 to-white" data-id="element-7375">
        <header className="bg-white/90 border-b border-gray-200 sticky top-0 z-50 backdrop-blur-sm" data-id="element-7376">
          <div className="max-w-3xl mx-auto px-6 py-4" data-id="element-7377">
            <div className="flex items-center justify-between" data-id="element-7378">
              <Link to="/" className="text-2xl font-bold tracking-tight text-gray-900" data-id="element-7379">
                🚩 ToxicDetector
              </Link>
              <button onClick={handleShare} className="p-2.5 hover:bg-gray-50 rounded-lg transition-colors" aria-label="記事を共有" data-id="element-7380">
                <Share2 size={20} className="text-gray-600" data-id="element-7381" />
              </button>
            </div>
          </div>
        </header>

        <article className="max-w-3xl mx-auto w-full px-6 py-12" data-id="element-7382">
          <Link to="/blog" className="inline-flex items-center text-gray-600 text-sm mb-10 hover:text-gray-900 transition-colors group" data-id="element-7383">
            <ArrowLeft size={16} className="mr-2 group-hover:-translate-x-1 transition-transform" data-id="element-7384" />
            ブログに戻る
          </Link>

          <header className="mb-12" data-id="element-7385">
            <h1 className="text-4xl md:text-5xl font-bold mb-6 tracking-tight leading-tight text-gray-900" data-id="element-7386">
              {articleData.title}
            </h1>
            <div className="flex items-center text-gray-600 text-sm gap-3" data-id="element-7387">
              <time dateTime={articleData.publishDate} data-id="element-7388">
                {new Date(articleData.publishDate).toLocaleDateString('ja-JP', {
                year: 'numeric',
                month: 'long',
                day: 'numeric'
              })}
              </time>
              <span className="text-gray-300" data-id="element-7389">•</span>
              <span data-id="element-7390">{articleData.author}</span>
            </div>
          </header>

          <div className="mb-12" data-id="element-7391">
            <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/eAKNBAYBhED67QeywsaDY6/1763120946474.jpg" alt="AIを使用して隠れナルシシストの操作の兆候についてテキストメッセージを分析する女性" className="w-full rounded-2xl shadow-sm border border-gray-200" data-id="element-7392" />
          </div>

          <div className="bg-white rounded-xl p-6 border border-gray-200 mb-12" data-id="element-7393">
            <h2 className="font-bold text-lg mb-4 text-gray-900" data-id="element-7394">目次</h2>
            <ul className="space-y-3 text-sm" data-id="element-7395">
              <li data-id="element-7396">
                <a href="#emotional-manipulation" className="text-gray-600 hover:text-gray-900 transition-colors flex items-center gap-2" data-id="element-7397">
                  <span className="text-gray-400" data-id="element-7398">→</span> 1.
                  すべてのメッセージにおける感情操作
                </a>
              </li>
              <li data-id="element-7399">
                <a href="#gaslighting" className="text-gray-600 hover:text-gray-900 transition-colors flex items-center gap-2" data-id="element-7400">
                  <span className="text-gray-400" data-id="element-7401">→</span> 2.
                  徐々に構築されるガスライティング
                </a>
              </li>
              <li data-id="element-7402">
                <a href="#passive-aggressive" className="text-gray-600 hover:text-gray-900 transition-colors flex items-center gap-2" data-id="element-7403">
                  <span className="text-gray-400" data-id="element-7404">→</span> 3.
                  受動的攻撃的なコメント
                </a>
              </li>
              <li data-id="element-7405">
                <a href="#playing-victim" className="text-gray-600 hover:text-gray-900 transition-colors flex items-center gap-2" data-id="element-7406">
                  <span className="text-gray-400" data-id="element-7407">→</span> 4. 常に被害者を演じる
                </a>
              </li>
              <li data-id="element-7408">
                <a href="#love-bombing" className="text-gray-600 hover:text-gray-900 transition-colors flex items-center gap-2" data-id="element-7409">
                  <span className="text-gray-400" data-id="element-7410">→</span> 5.
                  ラブボミングとその後の撤回
                </a>
              </li>
              <li data-id="element-7411">
                <a href="#hidden-control" className="text-gray-600 hover:text-gray-900 transition-colors flex items-center gap-2" data-id="element-7412">
                  <span className="text-gray-400" data-id="element-7413">→</span> 6.
                  隠されたコントロールと監視
                </a>
              </li>
              <li data-id="element-7414">
                <a href="#inconsistent-tone" className="text-gray-600 hover:text-gray-900 transition-colors flex items-center gap-2" data-id="element-7415">
                  <span className="text-gray-400" data-id="element-7416">→</span> 7.
                  チャネル間の不一致なトーン
                </a>
              </li>
            </ul>
          </div>

          <div className="prose prose-lg max-w-none" data-id="element-7417">
            <p className="text-xl mb-8 leading-relaxed text-gray-700" data-id="element-7418">
              元カレが魅力的で思いやりがあるように見えながら、舞台裏であなたを操作していたと感じたことはありますか？それは
              <strong data-id="element-7419">隠れナルシシストの典型的な兆候</strong>
              です。明白なナルシシストとは異なり、隠れナルシシストは微妙な感情的戦術の背後に操作を隠します。
            </p>
            <p className="mb-12 text-lg leading-relaxed text-gray-600" data-id="element-7420">
              当社の<strong data-id="element-7421">AIは隠された操作を検出</strong>
              し、テキストを分析するだけで即座に識別します。その方法は以下の通りです。
            </p>

            <section id="emotional-manipulation" className="mb-12" data-id="element-7422">
              <h2 className="text-3xl font-bold mb-6 tracking-tight text-gray-900" data-id="element-7423">
                1️⃣ すべてのメッセージにおける感情操作
              </h2>
              <p className="mb-6 text-lg leading-relaxed text-gray-600" data-id="element-7424">
                隠れナルシシストは感情をねじ曲げて自分の思い通りにします。
              </p>
              <div className="bg-gray-50 border-l-4 border-purple-600 p-6 mb-6 rounded-r-xl" data-id="element-7425">
                <p className="italic text-gray-700 text-lg" data-id="element-7426">
                  「君がこれで怒るなんて信じられない...」
                </p>
              </div>
              <p className="text-lg leading-relaxed text-gray-600" data-id="element-7427">
                AIは、日常のメッセージに隠された微妙な罪悪感の誘発や感情的な圧力を検出します。
              </p>
            </section>

            <section id="gaslighting" className="mb-12" data-id="element-7428">
              <h2 className="text-3xl font-bold mb-6 tracking-tight text-gray-900" data-id="element-7429">
                2️⃣ 徐々に構築されるガスライティング
              </h2>
              <div className="bg-gray-50 border-l-4 border-purple-600 p-6 mb-6 rounded-r-xl" data-id="element-7430">
                <p className="italic text-gray-700 text-lg" data-id="element-7431">
                  「君はそれを間違って覚えている...」
                </p>
              </div>
              <p className="mb-6 text-lg leading-relaxed text-gray-600" data-id="element-7432">
                隠れナルシシストはあなた自身の記憶を疑わせます。AIは現実が歪められている繰り返しの事例にフラグを立てます。
              </p>
            </section>

            <section id="passive-aggressive" className="mb-12" data-id="element-7433">
              <h2 className="text-3xl font-bold mb-6 tracking-tight text-gray-900" data-id="element-7434">
                3️⃣ 受動的攻撃的なコメント
              </h2>
              <div className="bg-gray-50 border-l-4 border-purple-600 p-6 mb-6 rounded-r-xl" data-id="element-7435">
                <p className="italic text-gray-700 text-lg" data-id="element-7436">
                  「もちろん、君が幸せなら何でもいいよ...」
                </p>
              </div>
              <p className="text-lg leading-relaxed text-gray-600" data-id="element-7437">
                受動的攻撃性は隠れナルシシズムの特徴です。AIは皮肉、陰湿な当てこすり、隠された敵意を認識します。
              </p>
            </section>

            <section id="playing-victim" className="mb-12" data-id="element-7438">
              <h2 className="text-3xl font-bold mb-6 tracking-tight text-gray-900" data-id="element-7439">
                4️⃣ 常に被害者を演じる
              </h2>
              <div className="bg-gray-50 border-l-4 border-purple-600 p-6 mb-6 rounded-r-xl" data-id="element-7440">
                <p className="italic text-gray-700 text-lg" data-id="element-7441">
                  「君のためにこれだけしてあげたのに...」
                </p>
              </div>
              <p className="mb-6 text-lg leading-relaxed text-gray-600" data-id="element-7442">
                隠れナルシシストはしばしば責任を転嫁し、自分自身を被害者に仕立て上げます。AIはあなたに罪悪感を感じさせるように設計されたフレーズを検出します。
              </p>
            </section>

            <section id="love-bombing" className="mb-12" data-id="element-7443">
              <h2 className="text-3xl font-bold mb-6 tracking-tight text-gray-900" data-id="element-7444">
                5️⃣ ラブボミングとその後の撤回
              </h2>
              <div className="bg-gray-50 border-l-4 border-purple-600 p-6 mb-6 rounded-r-xl" data-id="element-7445">
                <p className="italic text-gray-700 text-lg" data-id="element-7446">
                  「君は僕が愛した唯一の人だ 😢」 → 音信不通
                </p>
              </div>
              <p className="text-lg leading-relaxed text-gray-600" data-id="element-7447">
                激しい愛情の後に感情的な距離が続くこの古典的なサイクルは危険信号です。AIは複数のチャットにわたってこれらのパターンを識別します。
              </p>
            </section>

            <section id="hidden-control" className="mb-12" data-id="element-7448">
              <h2 className="text-3xl font-bold mb-6 tracking-tight text-gray-900" data-id="element-7449">
                6️⃣ 隠されたコントロールと監視
              </h2>
              <div className="bg-gray-50 border-l-4 border-purple-600 p-6 mb-6 rounded-r-xl" data-id="element-7450">
                <p className="italic text-gray-700 text-lg" data-id="element-7451">
                  「ちょっと確認しただけ...また」
                </p>
              </div>
              <p className="mb-6 text-lg leading-relaxed text-gray-600" data-id="element-7452">
                ケアを装った微妙なコントロールは隠れた戦術です。AIは明白な攻撃性なしに繰り返されるチェック行動にフラグを立てます。
              </p>
            </section>

            <section id="inconsistent-tone" className="mb-12" data-id="element-7453">
              <h2 className="text-3xl font-bold mb-6 tracking-tight text-gray-900" data-id="element-7454">
                7️⃣ チャネル間の不一致なトーン
              </h2>
              <div className="bg-gray-50 border-l-4 border-purple-600 p-6 mb-6 rounded-r-xl" data-id="element-7455">
                <p className="italic text-gray-700 text-lg" data-id="element-7456">
                  グループチャット: 遊び心 / 1対1: 批判的
                </p>
              </div>
              <p className="text-lg leading-relaxed text-gray-600" data-id="element-7457">
                隠れナルシシストはしばしば公の場では行動を隠し、私的には操作します。AIは会話を比較して不一致を強調します。
              </p>
            </section>

            <section className="mb-12" data-id="element-7458">
              <h2 className="text-3xl font-bold mb-6 tracking-tight text-gray-900" data-id="element-7459">
                🛡 自分を守る方法
              </h2>
              <div className="bg-white rounded-xl border border-gray-200 p-6" data-id="element-7460">
                <ul className="space-y-3 text-lg text-gray-600" data-id="element-7461">
                  <li className="flex items-start gap-3" data-id="element-7462">
                    <span className="text-purple-600 font-bold" data-id="element-7463">•</span>
                    <span data-id="element-7464">
                      直感を信じてください。危険信号を無視しないでください。
                    </span>
                  </li>
                  <li className="flex items-start gap-3" data-id="element-7465">
                    <span className="text-purple-600 font-bold" data-id="element-7466">•</span>
                    <span data-id="element-7467">
                      明確にするためにスクリーンショットを保存してください。
                    </span>
                  </li>
                  <li className="flex items-start gap-3" data-id="element-7468">
                    <span className="text-purple-600 font-bold" data-id="element-7469">•</span>
                    <span data-id="element-7470">友人やセラピストと経験を共有してください。</span>
                  </li>
                  <li className="flex items-start gap-3" data-id="element-7471">
                    <span className="text-purple-600 font-bold" data-id="element-7472">•</span>
                    <span data-id="element-7473">
                      Toxic
                      Detectorのようなツールを使用してパターンを特定してください。
                    </span>
                  </li>
                </ul>
              </div>
            </section>

            <section className="mb-12" data-id="element-7474">
              <h2 className="text-3xl font-bold mb-6 tracking-tight text-gray-900" data-id="element-7475">
                💀 自分の目で確かめる
              </h2>
              <p className="mb-6 text-lg leading-relaxed text-gray-600" data-id="element-7476">
                隠れナルシシズムは見つけるのが難しいかもしれませんが、AIは見逃しません。チャットをアップロードして即座に分析を取得してください：
              </p>
              <div className="bg-white border border-gray-200 rounded-xl p-6 mb-6" data-id="element-7477">
                <p className="text-gray-900 font-bold text-center text-lg" data-id="element-7478">
                  "🚩 78% 操作を検出。隠れた戦術が特定されました！"
                </p>
              </div>
            </section>

            <section id="faq" className="mb-12" data-id="element-7479">
              <h2 className="text-3xl font-bold mb-8 tracking-tight text-gray-900" data-id="element-7480">
                よくある質問
              </h2>
              <div className="space-y-4" data-id="element-7481">
                {faqSchema.mainEntity.map((faq, index) => <details key={index} className="bg-white rounded-xl border border-gray-200 overflow-hidden group" data-id="element-7482">
                    <summary className="px-6 py-4 cursor-pointer font-semibold text-base text-gray-900 hover:bg-gray-50 transition-colors flex items-center justify-between" data-id="element-7483">
                      <span data-id="element-7484">{faq.name}</span>
                      <ChevronDown size={20} className="text-gray-400 group-open:rotate-180 transition-transform" data-id="element-7485" />
                    </summary>
                    <div className="px-6 pb-4 text-gray-600 leading-relaxed text-sm" data-id="element-7486">
                      {faq.acceptedAnswer.text}
                    </div>
                  </details>)}
              </div>
            </section>
          </div>

          <div className="bg-purple-600 rounded-2xl p-10 text-center text-white mt-16" data-id="element-7487">
            <h2 className="text-3xl font-bold mb-4 tracking-tight" data-id="element-7488">
              💀 真実を明らかにする準備はできましたか？
            </h2>
            <p className="text-purple-100 mb-8 text-lg leading-relaxed max-w-2xl mx-auto" data-id="element-7489">
              推測するのはやめましょう。テキストをToxic
              Detectorにアップロードして、即座に毒性スコアを取得してください。当社のAIは、あなたが見逃したかもしれない隠れた操作を明らかにします。
            </p>
            <div className="bg-white/10 backdrop-blur-sm rounded-xl p-6 mb-8 border border-white/20" data-id="element-7490">
              <p className="font-bold text-xl" data-id="element-7491">
                "🚩 78% 操作を検出。隠れた戦術が特定されました！"
              </p>
            </div>
            <Link to="/signup" className="inline-block bg-white text-purple-600 px-10 py-4 rounded-lg font-bold text-lg hover:bg-gray-50 transition-colors" data-id="element-7492">
              今すぐチャットをスキャン →
            </Link>
          </div>

          <RelatedBlogPosts posts={[{
          title: 'AIが即座に検知するガスライティングの7つの兆候',
          description: 'AIがテキスト会話で検出する主要なガスライティングパターンを学びます。',
          slug: '7-signs-of-gaslighting',
          emoji: '💀'
        }, {
          title: '受動的攻撃的なテキストへの究極のガイド',
          description: 'テキストメッセージでの受動的攻撃的な行動と隠された操作を見つけます。',
          slug: 'passive-aggressive-texts-guide',
          emoji: '😤'
        }]} data-id="element-7493" />

          <div className="mt-12 text-center" data-id="element-7494">
            <button onClick={handleShare} className="inline-flex items-center text-gray-600 hover:text-gray-900 font-medium transition-colors text-sm" data-id="element-7495">
              <Share2 size={18} className="mr-2" data-id="element-7496" />
              この記事を共有
            </button>
          </div>
        </article>

        <footer className="bg-white border-t border-gray-200 py-12 mt-16" data-id="element-7497">
          <div className="max-w-3xl mx-auto px-6 text-center" data-id="element-7498">
            <p className="text-gray-500 text-sm" data-id="element-7499">
              © {new Date().getFullYear()} ToxicDetector. 全著作権所有。
            </p>
          </div>
        </footer>
      </div>
    </>;
}